export default __webpack_public_path__ + "static/media/Amc.3187a030.png";